import {toArray} from 'lodash';

const createSelectOptionsFromJson = (optionsList, jsonData) => {
    for (const key in jsonData) {
        if (Object.prototype.hasOwnProperty.call(jsonData, key)) {
            optionsList.push({
                value: key,
                label: jsonData[key]
            });
        }
    }
};

const createCountrySelectOptions = (optionsList, respData) => {
    respData.forEach((entry) => {
        if (entry.specialRegionCode) {
            optionsList.push({
                value: entry.specialRegionCode,
                label: entry.specialRegionDisplayName
            });
        } else {
            optionsList.push({
                value: entry.countryCode,
                label: entry.countryName
            });
        }
    });
};


const getSelectOptions = (respData) => {
    const optionsList = [];
    optionsList.push({
        value: '',
        label: ''
    });

    const arrayConstructor = [].constructor;
    const objectConstructor = {}.constructor;
    if (respData) {
        if (respData.constructor === arrayConstructor) {
            createCountrySelectOptions(optionsList, respData);
        } else if (respData.constructor === objectConstructor) {
            createSelectOptionsFromJson(optionsList, respData);
        }
    }

    return optionsList;
};

const getExpireYears = () => {
    const optionsList = [];
    optionsList.push({
        value: '',
        label: ''
    });
    let year = (new Date()).getFullYear();
    const maxYear = year + 15; // options list up to 15 years
    while (year <= maxYear) {
        optionsList.push({
            value: year,
            label: year
        });
        ++year;
    }

    return optionsList;
};

const getExpireMonths = () => {
    const optionsList = [];
    optionsList.push({
        value: '',
        label: ''
    });
    let month = 1;
    while (month <= 12) {
        optionsList.push({
            value: month,
            label: month
        });
        ++month;
    }

    return optionsList;
};

const handleFormFields = (event, props) => {
    const {
        handleCountryChange,
        handleAddressLine1Change,
        handleAddressLine2Change,
        handleCityChange,
        handleStateChange,
        handleSelectStateChange,
        handlePostalCodeChange
    } = props;
    const formId = event.target.id.split('_')[1];
    return {
        'country': () => handleCountryChange(event),
        'address1': () => handleAddressLine1Change(event),
        'address2': () => handleAddressLine2Change(event),
        'city': () => handleCityChange(event),
        'stateProvince': () => {
            const state = (event.target.tagName === 'INPUT') ?
                handleStateChange(event) : handleSelectStateChange(event);
            return state;
        },
        'postalCode': () => handlePostalCodeChange(event)
    }[formId || event.target.id]();
};

const handleFormFieldsOnBlur = (event, props) => {
    const {
        onCountryBlur,
        onAddress1Blur,
        onAddress2Blur,
        onCityBlur,
        onStateBlur,
        onPostalCodeBlur,
        onSelectedStateBlur
    } = props;
    const formId = event.target.id.split('_')[1];

    return {
        'country': () => onCountryBlur(event),
        'address1': () => onAddress1Blur(event),
        'address2': () => onAddress2Blur(event),
        'city': () => onCityBlur(event),
        'stateProvince': () => {
            const state = (event.target.tagName === 'INPUT') ?
                onStateBlur(event) : onSelectedStateBlur(event);
            return state;
        },
        'postalCode': () => onPostalCodeBlur(event)
    }[formId || event.target.id]();
};

const addressFormValuesMapper = (props) => {
    const addressFormValues = {};
    const {addressType, addressLine1Val, addressLine2Val, cityVal, stateVal, stateSelectVal, postalCodeVal} =props;
    const addressFormIdPrefix = addressType ? `${addressType}_` : '';

    addressFormValues[`${addressFormIdPrefix}address1`] = addressLine1Val;
    addressFormValues[`${addressFormIdPrefix}address2`] = addressLine2Val;
    addressFormValues[`${addressFormIdPrefix}city`] = cityVal;
    addressFormValues[`${addressFormIdPrefix}stateProvince`] = (stateVal || stateSelectVal);
    addressFormValues[`${addressFormIdPrefix}postalCode`] = postalCodeVal;

    return addressFormValues;
};

const addressFormErrorMapper = (props) => {
    const addressFormErrors = {};
    const {translations, addressType, countryError, addressLine1Error, cityError, stateError, StateSelectError, postalCodeError} = props;
    const addressFormIdPrefix = addressType ? `${addressType}_` : '';

    addressFormErrors[`${addressFormIdPrefix}country`] = translations[countryError];
    addressFormErrors[`${addressFormIdPrefix}address1`] = translations[addressLine1Error];
    addressFormErrors[`${addressFormIdPrefix}city`] = translations[cityError];
    addressFormErrors[`${addressFormIdPrefix}stateProvince`] = translations[(stateError || StateSelectError)];
    addressFormErrors[`${addressFormIdPrefix}postalCode`] = translations[postalCodeError];

    return addressFormErrors;
};

const getFormElementsIds = (addressType) => {
    const addressFormId = addressType ? `${addressType}_addressForm` : 'addressForm';
    const formElements = document.getElementById(addressFormId).elements;
    return toArray(formElements).map((entry) => entry.id);
};

export {
    getSelectOptions,
    getExpireYears,
    getExpireMonths,
    handleFormFields,
    handleFormFieldsOnBlur,
    addressFormValuesMapper,
    addressFormErrorMapper,
    getFormElementsIds
};
